import React from 'react';

const CorqTheme = {
  headerLogo: {
    src: '/themes/theme/corq/corq-logo.svg',
    alt: 'Corq Agency Logo',
    size: 35,
  },
  darkLogo: {
    src: '/themes/theme/corq/corq-logo.svg',
    alt: 'Corq Agency Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 90,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'CORQ CREATORS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="90" src="/themes/theme/corq/logo.png" alt="Corq Agency Logo" />
      <br /><br />
      <h3>CORQ CREATORS</h3>
    </div>
  ),
  shareSite: 'https://share.corq.studio',
};

export default CorqTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/corq-agency.js
 **/